import React from 'react';
import Appbar from '../Appbar';
import Footer from '../Footer';

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col min-h-screen w-full">
      <Appbar />
      <div className="flex-grow max-w-3xl mx-auto p-5 leading-relaxed mt-[600px]">
        <h1 className="text-2xl font-bold">Privacy Policy for Wordy Gifts Ltd.</h1>
        <p><strong>Last Updated:</strong> 20th February 2025</p>
        
        <p>
          At <strong>Wordy Gifts Ltd.</strong> ("we", "us", "our"), we value your privacy and are committed to 
          protecting your personal information. This Privacy Policy explains how we collect, use, share, and 
          safeguard your data when you use our website and services. By accessing or using our website and 
          services, you agree to the collection and use of information in accordance with this policy.
        </p>

        <h2 className="text-xl font-semibold mt-5">1. Information We Collect</h2>
        <p>We collect the following personal data from customers and recipients:</p>
        <ul className="list-disc pl-5">
          <li><strong>Customer Information:</strong> Your name, email address, and payment information (processed via Stripe).</li>
          <li><strong>Recipient Information:</strong> The name and mobile phone number of the person you are sending messages to.</li>
        </ul>
        <p>This data is collected when you input it through our subscription form on our website.</p>

        <h2 className="text-xl font-semibold mt-5">2. How We Use Your Data</h2>
        <p>We use your data for the following purposes:</p>
        <ul className="list-disc pl-5">
          <li>To process payments for your subscription via Stripe.</li>
          <li>To send the personalized messages you’ve requested to the recipient.</li>
          <li>To provide customer support and assistance regarding your subscription.</li>
          <li>To improve our services and website functionality.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-5">3. Sharing Your Data</h2>
        <p>We may share your data with the following third-party services:</p>
        <ul className="list-disc pl-5">
          <li><strong>ChatGPT (OpenAI):</strong> For generating the personalized messages sent to the recipient.</li>
          <li><strong>Stripe:</strong> For processing payments and managing subscriptions.</li>
          <li><strong>Twilio:</strong> For sending SMS messages to the recipient.</li>
        </ul>
        <p>These third parties are committed to safeguarding your information and are required to handle it in accordance with applicable privacy laws.</p>

        <h2 className="text-xl font-semibold mt-5">4. Data Retention</h2>
        <p>We will retain your data for as long as your subscription remains active. Once your subscription is cancelled or expired, we will delete your personal data within a reasonable timeframe unless otherwise required by law.</p>

        <h2 className="text-xl font-semibold mt-5">5. Data Protection</h2>
        <p>We prioritize the security of your data. We use Stripe for secure payment processing, ensuring that payment details are handled with the highest level of security available. Our website employs encryption and other security measures to protect your information from unauthorized access, disclosure, alteration, and destruction.</p>

        <h2 className="text-xl font-semibold mt-5">6. Your Rights</h2>
        <p>You have the right to:</p>
        <ul className="list-disc pl-5">
          <li>Access your personal data, including the information we hold about you.</li>
          <li>Delete your personal data or request that we delete it (subject to any legal requirements to retain data).</li>
          <li>Opt-out from receiving future messages or marketing communication by contacting us directly or unsubscribing where applicable.</li>
        </ul>
        <p>If you wish to exercise any of these rights, please contact us at <strong>[Your Contact Email]</strong>.</p>

        <h2 className="text-xl font-semibold mt-5">7. Cookies and Tracking Technologies</h2>
        <p>Our website uses cookies to enhance your browsing experience. These cookies may collect information about how you use our website, helping us improve functionality and tailor our services. You can manage cookie preferences through your browser settings.</p>
        <p>For more information about cookies, please refer to our <strong>Cookie Policy</strong>.</p>

        <h2 className="text-xl font-semibold mt-5">8. Children’s Privacy</h2>
        <p>We do not knowingly collect personal information from children under the age of 16. If you believe that we have inadvertently collected data from a child, please contact us immediately, and we will take steps to remove that information.</p>

        <h2 className="text-xl font-semibold mt-5">9. Compliance with GDPR</h2>
        <p>As we operate in the European Union (EU), we comply with the General Data Protection Regulation (GDPR). This means that you have rights over your personal data, including the right to access, correct, delete, and limit the use of your information. If you believe your data has been mishandled, you have the right to file a complaint with the relevant data protection authority.</p>

        <h2 className="text-xl font-semibold mt-5">10. Changes to This Privacy Policy</h2>
        <p>We reserve the right to update this Privacy Policy at any time. Any changes will be posted on this page with an updated date. By continuing to use our services after any changes, you agree to the updated terms.</p>

        <h2 className="text-xl font-semibold mt-5">11. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy or how we handle your personal data, please contact us at:</p>
        <ul className="list-disc pl-5">
          <li><strong>Email:</strong> <a href="mailto:enquiries@wordygift.com" className="text-blue-600 underline">enquiries@wordygift.com</a></li>
        </ul>

        <p className="mt-5">By using our services, you acknowledge that you have read and understand this Privacy Policy. Thank you for choosing <strong>Wordy Gifts Ltd.</strong></p>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;